export default __webpack_public_path__ + "static/media/User-not-invited.dd2a2065.png";